import styled from 'styled-components'

export const OverlayModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContainerModal = styled.div`
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`

export const WrapperMapa = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative; /* Necessário para o card flutuante se posicionar aqui */
`

export const CardFlutuante = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  padding: 12px 20px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  gap: 12px;
  z-index: 10; /* Garante que fique acima do mapa */
  align-items: center;
`

export const CardFlutuanteOpcoes = styled.div`
  position: absolute;
  width: 250px;
  top: 30px;
  left: 90%;
  transform: translateX(-50%);
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 10; /* Garante que fique acima do mapa */

  .pontos__grid {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    border: 2px solid #d9d9d9;
    padding: 10px;
    border-radius: 7px;
  }

  .pontos__fora {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ff0000;
    border-radius: 6px;
    color: white;
    font-weight: 600;
  }
`

export const Botao = styled.button`
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  color: #333;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f5f5f5;
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f9f9f9;
  }
`

export const BotaoSalvar = styled(Botao)`
  background-color: #0d6efd;
  color: white;
  border: none;

  &:hover:not(:disabled) {
    background-color: #0b5ed7;
  }
`

export const BotaoCancelar = styled(Botao)`
  color: #dc3545;
  border-color: #dc3545;
  background-color: transparent;

  &:hover {
    background-color: #fff5f5;
  }
`
